import { z } from 'zod'

import { fileSchema } from './file'
import { ReportType, ReportState } from '../constants/report'
import { MetricPeriod, MetricType } from '../constants/metric'
import { dbEntitySchema } from './system'
import { personDisplaySchema } from './personDisplay'

export const reportSchema = dbEntitySchema.extend({
  created: z.coerce.date(),
  modified: z.coerce.date(),
  createdById: z.string().optional(),
  createdBy: personDisplaySchema.optional(),
  type: z.nativeEnum(ReportType),
  organization: z.string().optional(),
  state: z.nativeEnum(ReportState),
  files: z.array(fileSchema).optional(),
  options: z.record(z.string(), z.any()).optional(),
})

const booleanQuerySchema = z.preprocess((value) => {
  if (value === 'true') return true
  if (value === 'false') return false
  return value
}, z.boolean())

export const dataExportsListQuerySchema = z.object({
  organizationId: z.string().optional(),
  platformOnly: booleanQuerySchema.optional(),
  reportType: z.nativeEnum(ReportType).optional(),
  venueId: z.union([z.string(), z.array(z.string())]).optional(),
  skip: z.coerce.number().int().min(0).optional(),
  limit: z.coerce.number().int().min(0).optional(),
  sort: z.string().optional(),
})

export const dataExportsCreateBodySchema = z.object({
  reportType: z.nativeEnum(ReportType),
  organizationId: z.string().optional(),
  venueId: z.union([z.string(), z.array(z.string())]).optional(),
  query: z.record(z.string(), z.any()).default({}),
})

export const metricsReportOptionsSchema = z.object({
  dateStart: z.coerce.date(),
  dateEnd: z.coerce.date(),
  period: z.nativeEnum(MetricPeriod).default(MetricPeriod.DAILY),
  type: z
    .array(z.nativeEnum(MetricType))
    .default([MetricType.ADMISSION_GROUPS, MetricType.CUSTOMERS]),
  venueId: z.union([z.string(), z.array(z.string())]).optional(),
})

export const reportWithDownloadUrlSchema = reportSchema.extend({
  downloadUrl: z.string().nullable().optional(),
})

export const dataExportsListResponseSchema = z.object({
  data: z.array(reportWithDownloadUrlSchema),
  count: z.number().int().nonnegative(),
})

export const dataExportsDownloadResponseSchema = z.object({
  url: z.string(),
})
